import { render, staticRenderFns } from "./edit-wrap.vue?vue&type=template&id=26665688&"
import script from "./edit-wrap.vue?vue&type=script&lang=js&"
export * from "./edit-wrap.vue?vue&type=script&lang=js&"
import style0 from "./edit-wrap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports